// extracted by mini-css-extract-plugin
export default {"componentWrapper":"Details_componentWrapper__DZpM3","price":"Details_price__Vm0tq","title":"Details_title__MQtAn","label":"Details_label__bRQ3b"};